<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <template v-slot:activator="{ on, attrs }">
      <v-btn block v-bind="attrs" v-on="on">
        <v-icon>create_new_folder</v-icon> Create Department
      </v-btn>
    </template>
    <v-card flat>
      <v-card-title>
        Create your department
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle>
        Add details & members
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container class="px-0">
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="team.name"
                  label="Department Name"
                  outlined
                  maxlength="50"
                  :rules="[$rules.required]"
                  required
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <team-autocomplete
                  v-model="parent"
                  label="Parent Department"
                  :multiple="false"
                >
                </team-autocomplete>
                <strong>Note:</strong> Multiple departments can be added via the
                <router-link to="/company/members">member import</router-link>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-btn :loading="saving" @click="addTeam">
          <v-icon>create_new_folder</v-icon> Create Department
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TeamAutocomplete from "@/components/teams/TeamAutocomplete";
export default {
  name: "CreateTeamDialog",
  components: {
    TeamAutocomplete
  },
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    team: {
      name: "",
      parentId: null
    }
  }),
  watch: {
    dialog(val, oldVal) {
      if (val != oldVal) {
        this.team = {
          name: "",
          parentId: null
        };
      }
    }
  },
  computed: {
    parent: {
      get() {
        return [this.team.parentId];
      },
      set(val) {
        this.team.parentId = (val || [""])[0];
      }
    }
  },
  created() {},
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    addTeam() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("team/addTeam", this.team)
          .then(() => {
            this.$emit("save");
            this.$refs.form.reset();

            this.$root.$snackbarSuccess(`Department added`);

            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              `An error occurred while creating a department.`
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
